import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html'
})
export class TextareaComponent implements OnInit {
  @Input() label!: string;
  @Input() control!: FormControl;
  @Input() requiredErrorMessage!: string;
  @Input() required: boolean = false;

  ngOnInit() {
  }
}
